/**
 * Wide viewport: match rows use `picksCardInner` max width; hero must share it so avatars align with team columns.
 */
export const CHALLENGE_CARD_WIDE_INNER_MAX_WIDTH = 520;
